


import loader from "../img/loader.gif"
function Loading() {
  return (
    <div className='bg-black fixed  h-screen w-screen flex justify-center items-center'>
      
      
      <img src={loader} alt="" />
      
    </div>
  )
}

export default Loading
